import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/KebunLP.css";

const KebunLD = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [profil, setProfil] = useState({});
  const [trukList, setTrukList] = useState([]);
  const [penugasanAktif, setPenugasanAktif] = useState([]);
  const [riwayat, setRiwayat] = useState([]);
  const [statistikRiwayat, setStatistikRiwayat] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("truk");
  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const formatNumber = (value) => {
    if (value === null || value === undefined || isNaN(Number(value))) return "0";
    return new Intl.NumberFormat("id-ID").format(value);
  };

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    const fetchUserInfo = async () => {
      try {
        const response = await axios.get(
          "https://c-greenproject.org:7500/get_user_role",
          { withCredentials: true }
        );
        if (!response.data.error) {
          setUserInfo(response.data);
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    const fetchDetailLogistik = async () => {
      try {
        const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` };
        
        const [resProfil, resTruk, resAktif, resRiwayat] = await Promise.all([
          axios.get(`https://c-greenproject.org:7500/kebun/logistik/${id}/profil`, { headers }),
          axios.get(`https://c-greenproject.org:7500/kebun/logistik/${id}/truk`, { headers }),
          axios.get(`https://c-greenproject.org:7500/kebun/logistik/${id}/penugasan_aktif`, { headers }),
          axios.get(`https://c-greenproject.org:7500/kebun/logistik/${id}/riwayat`, { headers })
        ]);

        if (resProfil.data.profil) setProfil(resProfil.data.profil);
        if (resTruk.data.data) setTrukList(resTruk.data.data);
        if (resAktif.data.data) setPenugasanAktif(resAktif.data.data);
        if (resRiwayat.data.data) setRiwayat(resRiwayat.data.data);
        if (resRiwayat.data.statistik) setStatistikRiwayat(resRiwayat.data.statistik);

      } catch (error) {
        Swal.fire("Error", "Gagal memuat detail vendor logistik.", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchUserInfo();
    fetchDetailLogistik();
  }, [id]);

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      Swal.fire("Gagal", "Gagal logout.", "error");
    }
  };

  const handleLacakResi = async (trackingId) => {
    if (!trackingId || trackingId === "-") return;
    try {
      Swal.fire({
        title: "Memuat Data Pelacakan...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      const response = await axios.post(
        "https://c-greenproject.org:7500/lacak_pengiriman",
        { tracking_id: trackingId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      );

      const data = response.data;
      
      let driversHtml = "";
      if (data.logistik_info && data.logistik_info.length > 0) {
        const info = data.logistik_info[0];
        if (info.drivers && info.drivers.length > 0) {
          driversHtml = info.drivers.map(d => `
            <div class="border-bottom py-2 small text-start">
              <div><strong>Driver:</strong> ${d.nama_driver || "-"}</div>
              <div><strong>Plat Truk:</strong> ${d.plat_truk || "-"}</div>
              <div><strong>Lokasi Terakhir:</strong> ${d.lokasi || "-"}</div>
              <div><strong>Status:</strong> <span class="badge bg-secondary">${d.status_driver || "-"}</span></div>
              <div><strong>Waktu Update:</strong> ${d.tanggal_update || "-"}</div>
            </div>
          `).join("");
        } else {
          driversHtml = "<p class='text-muted small'>Belum ada pembaruan dari driver.</p>";
        }
      }

      Swal.fire({
        title: `Detail Resi: ${data.tracking_id}`,
        html: `
          <div class="text-start small" style="line-height: 1.6;">
            <p class="mb-1"><strong>Nama Petani:</strong> ${data.nama_petani || "-"}</p>
            <p class="mb-1"><strong>Pabrik Tujuan:</strong> ${data.Pabrik_tujuan || "-"}</p>
            <p class="mb-1"><strong>Berat Sawit Awal:</strong> ${data.berat_sawit_awal ? formatNumber(data.berat_sawit_awal) + " Kg" : "-"}</p>
            <p class="mb-1"><strong>Berat Sawit Akhir:</strong> ${data.berat_sawit_akhir ? formatNumber(data.berat_sawit_akhir) + " Kg" : "-"}</p>
            <p class="mb-1"><strong>Status Pengiriman:</strong> <span class="badge bg-success">${data.logistik_info?.[0]?.status_Pengiriman || "-"}</span></p>
            <p class="mb-1"><strong>Tanggal Kirim:</strong> ${data.tanggal_pengiriman || "-"}</p>
            <p class="mb-3"><strong>Tanggal Diterima:</strong> ${data.tanggal_diterima || "-"}</p>
            <hr/>
            <p class="fw-bold mb-2">Riwayat Armada & Driver:</p>
            ${driversHtml}
          </div>
        `,
        width: "650px",
        confirmButtonColor: "#198754",
        confirmButtonText: "Tutup"
      });

    } catch (error) {
      Swal.fire("Gagal", error.response?.data?.error || "Gagal mengambil data pelacakan.", "error");
    }
  };

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      <div className="header bg-white shadow-sm border-bottom">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span className="fw-medium text-secondary">{userInfo.full_name} |</span>
          <button
            className="btn btn-outline-danger btn-sm rounded-pill px-3 ms-2"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        <div className="sidebar p-3 bg-white shadow-sm" id="sidebar">
          <p id="sidebar-title" className="text-muted small mb-1">Portal Sistem Traceability</p>
          <h6 id="sidebar-subtitle" className="fw-bold text-success mb-3">Telsa Super Apps</h6>
          <p id="sidebar-date" className="bg-light p-2 rounded-3 text-muted small fw-medium d-flex align-items-center gap-2">
            <img src="/static/schedule_11145854.png" alt="Date" style={{ width: "16px" }} />
            {tanggal}
          </p>
          <div className="list-group list-group-flush mt-3" id="sidebar-menu">
            <div onClick={() => navigate("/kebun")} className="list-group-item border-0 rounded-3 mb-1" style={{ cursor: "pointer" }}>
              Beranda
            </div>
            <div onClick={() => navigate("/KebunP")} className="list-group-item border-0 rounded-3 mb-1" style={{ cursor: "pointer" }}>
              Petani
            </div>
            <div onClick={() => navigate("/KebunL")} className="list-group-item border-0 rounded-3 mb-1 bg-success text-white" style={{ cursor: "pointer" }}>
              Logistik
            </div>
            <div onClick={() => navigate("/kebunpabrik")} className="list-group-item border-0 rounded-3 mb-1" style={{ cursor: "pointer" }}>
              Pabrik
            </div>
          </div>
        </div>

        <div className="main-content flex-grow-1 p-4 w-100">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="fw-bold text-dark mb-0">Rincian Vendor Logistik</h2>
            <button className="btn btn-outline-secondary btn-sm rounded-pill px-4 shadow-sm" onClick={() => navigate(-1)}>
              <i className="fa fa-arrow-left me-2"></i> Kembali
            </button>
          </div>

          <div className="divider mb-4"></div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-success" role="status"></div>
              <p className="text-muted mt-2">Memuat profil dan armada logistik...</p>
            </div>
          ) : (
            <>
              <div className="bg-white p-4 rounded-4 shadow-sm mb-4 border-start border-success border-4">
                <h3 className="fw-bold text-dark mb-1">{profil.nama_perusahaan || "Vendor Logistik"}</h3>
                <p className="text-muted mb-1"><i className="fa fa-map-marker-alt me-2"></i>{profil.alamat_kantor || "-"}</p>
                <p className="text-muted mb-0"><i className="fa fa-phone-alt me-2"></i>{profil.nomor_hp || "-"}</p>
                <hr />
                <div className="row text-center">
                  <div className="col-md-3">
                    <div className="text-muted small">Total Unit Truk</div>
                    <div className="fw-bold text-dark h5">{profil.total_truk_terdaftar || 0} Unit</div>
                  </div>
                  <div className="col-md-3">
                    <div className="text-muted small">Truk Siap (Tersedia)</div>
                    <div className="fw-bold text-success h5">{profil.truk_siap || 0} Unit</div>
                  </div>
                  <div className="col-md-3">
                    <div className="text-muted small">Total Kapasitas</div>
                    <div className="fw-bold text-secondary h5">{formatNumber(profil.total_kapasitas_angkut)} Kg</div>
                  </div>
                  <div className="col-md-3">
                    <div className="text-muted small">Kapasitas Tersedia</div>
                    <div className="fw-bold text-primary h5">{formatNumber(profil.kapasitas_tersedia)} Kg</div>
                  </div>
                </div>
              </div>

              <div className="bg-white p-4 rounded-4 shadow-sm">
                <ul className="nav nav-pills mb-4 gap-2">
                  <li className="nav-item">
                    <button
                      className={`nav-link rounded-pill px-4 fw-bold ${activeTab === "truk" ? "bg-success text-white shadow-sm" : "text-secondary bg-light"}`}
                      onClick={() => setActiveTab("truk")}
                    >
                      <i className="fa fa-truck me-2"></i> Manajemen Armada Truk ({trukList.length})
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link rounded-pill px-4 fw-bold ${activeTab === "penugasan" ? "bg-success text-white shadow-sm" : "text-secondary bg-light"}`}
                      onClick={() => setActiveTab("penugasan")}
                    >
                      <i className="fa fa-clipboard-list me-2"></i> Penugasan Aktif ({penugasanAktif.length})
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link rounded-pill px-4 fw-bold ${activeTab === "riwayat" ? "bg-success text-white shadow-sm" : "text-secondary bg-light"}`}
                      onClick={() => setActiveTab("riwayat")}
                    >
                      <i className="fa fa-history me-2"></i> Riwayat & Performa ({riwayat.length})
                    </button>
                  </li>
                </ul>

                {activeTab === "truk" && (
                  <div>
                    <h5 className="fw-bold text-dark mb-3">Daftar Seluruh Truk & Pengemudi</h5>
                    <div className="table-responsive">
                      <table className="table table-hover align-middle text-center" style={{ fontSize: "0.85rem" }}>
                        <thead className="table-light">
                          <tr>
                            <th>No</th>
                            <th>Plat Nomor</th>
                            <th>Kode Unik</th>
                            <th>Nama Driver</th>
                            <th>Kapasitas Angkut</th>
                            <th>Status Truk</th>
                          </tr>
                        </thead>
                        <tbody>
                          {trukList.length > 0 ? (
                            trukList.map((truk, index) => (
                              <tr key={truk.id}>
                                <td className="fw-bold text-muted">{index + 1}</td>
                                <td className="font-monospace fw-bold">{truk.plat_nomor}</td>
                                <td className="text-secondary">{truk.kode_unik}</td>
                                <td>{truk.driver_nama}</td>
                                <td className="font-monospace">{formatNumber(truk.kapasitas_angkut)} Kg</td>
                                <td>
                                  {truk.status_truk?.toLowerCase() === "tersedia" ? (
                                    <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-1 rounded-pill">Tersedia</span>
                                  ) : (
                                    <span className="badge bg-warning-subtle text-warning border border-warning-subtle px-3 py-1 rounded-pill">{truk.status_truk}</span>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center py-4 text-muted">Belum ada armada truk yang terdaftar.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {activeTab === "penugasan" && (
                  <div>
                    <h5 className="fw-bold text-dark mb-3">Daftar Pengiriman & Penugasan Aktif</h5>
                    <div className="table-responsive">
                      <table className="table table-hover align-middle text-center" style={{ fontSize: "0.85rem" }}>
                        <thead className="table-light">
                          <tr>
                            <th>No</th>
                            <th>Tracking ID / Resi</th>
                            <th>Asal Petani</th>
                            <th>Pabrik Tujuan</th>
                            <th>Waktu Pengiriman</th>
                            <th>Status Pengiriman</th>
                          </tr>
                        </thead>
                        <tbody>
                          {penugasanAktif.length > 0 ? (
                            penugasanAktif.map((item, index) => (
                              <tr key={item.id}>
                                <td className="fw-bold text-muted">{index + 1}</td>
                                <td>
                                  {item.tracking_id && item.tracking_id !== "-" ? (
                                    <span
                                      className="font-monospace text-primary fw-bold text-decoration-underline"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleLacakResi(item.tracking_id)}
                                      title="Klik untuk melacak pengiriman"
                                    >
                                      {item.tracking_id}
                                    </span>
                                  ) : (
                                    <span className="text-muted">-</span>
                                  )}
                                </td>
                                <td className="text-start">
                                  <div className="fw-bold">{item.nama_petani}</div>
                                  <div className="text-muted small">{item.alamat_lahan}</div>
                                </td>
                                <td className="text-start">
                                  <div className="fw-bold">{item.pabrik_tujuan}</div>
                                  <div className="text-muted small">{item.alamat_pabrik}</div>
                                </td>
                                <td className="text-secondary">{item.tanggal_pengiriman}</td>
                                <td>
                                  <span className="badge bg-info-subtle text-info border border-info-subtle px-3 py-1 rounded-pill">{item.status_pengiriman}</span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center py-4 text-muted">Tidak ada penugasan pengiriman yang sedang aktif.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {activeTab === "riwayat" && (
                  <div>
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <div className="p-3 bg-light rounded-4 border">
                          <div className="text-muted small">Total Pengiriman Sukses</div>
                          <div className="h4 fw-bold text-success mb-0">{statistikRiwayat.total_pengiriman_sukses || 0} Pengiriman</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="p-3 bg-light rounded-4 border">
                          <div className="text-muted small">Total Berat Sawit Diangkut</div>
                          <div className="h4 fw-bold text-dark mb-0">{formatNumber(statistikRiwayat.total_berat_sawit_kg)} Kg</div>
                        </div>
                      </div>
                    </div>

                    <h5 className="fw-bold text-dark mb-3">Log Historis Pengiriman Terdahulu</h5>
                    <div className="table-responsive">
                      <table className="table table-hover align-middle text-center" style={{ fontSize: "0.85rem" }}>
                        <thead className="table-light">
                          <tr>
                            <th>No</th>
                            <th>Tracking ID</th>
                            <th>Asal Petani</th>
                            <th>Pabrik Tujuan</th>
                            <th>Berat Muatan</th>
                            <th>Waktu Selesai</th>
                          </tr>
                        </thead>
                        <tbody>
                          {riwayat.length > 0 ? (
                            riwayat.map((item, index) => (
                              <tr key={item.id}>
                                <td className="fw-bold text-muted">{index + 1}</td>
                                <td>
                                  {item.tracking_id && item.tracking_id !== "-" ? (
                                    <span
                                      className="font-monospace text-primary fw-bold text-decoration-underline"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleLacakResi(item.tracking_id)}
                                      title="Klik untuk melacak pengiriman"
                                    >
                                      {item.tracking_id}
                                    </span>
                                  ) : (
                                    <span className="text-muted">-</span>
                                  )}
                                </td>
                                <td className="text-start">
                                  <div className="fw-bold">{item.nama_petani}</div>
                                </td>
                                <td className="text-start">
                                  <div className="fw-bold">{item.pabrik_tujuan}</div>
                                </td>
                                <td className="font-monospace text-success fw-bold">{formatNumber(item.berat_muatan)} Kg</td>
                                <td className="text-secondary">{item.tanggal_pengiriman}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center py-4 text-muted">Belum ada riwayat pengiriman selesai untuk vendor ini.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default KebunLD;